export type RequestType = 'QUOTATION';
export type PreferredDeliveryTimeframe = 'ASAP' | 'WITHIN_10_DAYS' | 'MORE_THAN_10_DAYS' | 'NOT_LOOKING_TO_PURCHASE';

export interface QuotationLines {
  productId: number;
  quantity: {
    amount: number;
    unitOfMeasure: string;
  };
  preferredPackagingGroupId: number;
  otherPackagingInfo: string;
  colorId: number;
  desiredColor?: string;
  producerColorCode?: string;
}

export interface VerifiedRequestForQuotation {
  type: RequestType;
  preferredDeliveryTimeframe: PreferredDeliveryTimeframe;
  additionalInfo: string;
  deliveryAddressId: number;
  quotationRequestLines: QuotationLines[];
}

export interface GuestRequestForQuotation {
  preferredDeliveryTimeframe: PreferredDeliveryTimeframe;
  additionalInfo: string;
  deliveryAddress: RfqDeliveryAddress;
  contactInfo: RfqContactInfo;
  quotationRequestLines: QuotationLines[];
}

export interface RfqDeliveryAddress {
  country: string;
  city: string;
  postalCode: string;
}

export interface RfqContactInfo {
  firstName: string;
  lastName: string;
  email: string;
  language: string;
  phoneNumber: string;
  company: RfqCompanyInfo;
}

export interface RfqCompanyInfo {
  name: string;
  countryIsoCode: string;
}

export enum RfqStep {
  QUOTATION_DETAILS = 'quotation_details',
  VERIFY_EMAIL = 'verify_email',
  RECOGNIZED_EMAIL = 'recognized_email',
  CONTACT_DETAILS = 'contact_details',
  ADDRESS_DETAILS = 'address_details',
  DELIVERY_AREA = 'delivery_area',
  SUMMARY = 'summary',
  FINAL_MESSAGE = 'final_message'
}
